import {
  toLower as _toLower,
  isString as _isString,
  isEmpty as _isEmpty,
  startsWith as _startsWith,
} from 'lodash';
import qs from 'qs';

import { execute } from '../Daf'; // eslint-disable-line import/no-cycle
import CachePolicy from '../Daf/utilities/CachePolicy';
import { getServerPassword, setServerPassword } from '../KeyChain/KeyChain';

class Auth {
  accessToken = '';
  tokenType = '';
  refreshToken = '';
  scope = '';
  config = {};

  checkContentType = (headers, params) => {
    if (
      headers.hasOwnProperty('Content-Type') &&
      _toLower(headers['Content-Type']) === 'application/x-www-form-urlencoded' &&
      !_isString(params)
    ) {
      return qs.stringify(params);
    }
    return params;
  };

  authorize = async (url, headers = {}, params = {}) => {
    try {
      params = this.checkContentType(headers, params);
      this.config = {
        type: 'POST',
        url,
        headers,
        data: params,
      };
      const network = {
        policy: CachePolicy.NETWORK_ONLY,
      };
      const request = await execute(this.config, network);
      if ((request.status >= 200 && request.status <= 208) || request.status === 226) {
        const {
          access_token: accessToken,
          token_type: tokenType,
          refresh_token: refreshToken,
          scope,
          expires_at: expiresAt,
          refresh_token_expires: refreshTokenExpires,
          expires_in: expiresIn,
          issued_at: issuedAt,
        } = request.data;

        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
        this.tokenType = tokenType;
        this.scope = scope;

        const endPositon = _startsWith(url, 'http') ? 3 : 1;
        const serverName = url.split('/').slice(0, endPositon).join('/');

        setServerPassword(serverName, `${serverName}-userCredentials`, {
          accessToken,
          tokenType,
          refreshToken,
          scope,
          expiresAt,
          refreshTokenExpires,
          expiresIn,
          issuedAt,
          url,
          headers,
          params,
        }).catch(error => console.log('Failed to save token', error));
        return request;
      } else {
        return Promise.reject(request);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  };
  async handelAcessToken(options) {
    const endPositon = _startsWith(options.url, 'http') ? 3 : 1;
    const serverName = (options.url || '').split('/').slice(0, endPositon).join('/');

    try {
      const result = await getServerPassword(serverName);

      if (!result) {
        throw new Error('you must be authorize with access token to use request from AuthApi');
      }

      const {
        password: { accessToken, refreshToken, tokenType, scope, url, headers, params },
      } = result;

      this.accessToken = accessToken;
      this.refreshToken = refreshToken;
      this.tokenType = tokenType;
      this.scope = scope;
      this.config = {
        type: 'POST',
        url,
        headers,
        data: params,
      };
    } catch (error) {
      throw new Error('you must be authorize with access token to use request from AuthApi');
    }
  }
  request = async options => {
    try {
      if (_isEmpty(this.accessToken)) {
        await this.handelAcessToken(options);
      }

      const { headers = {}, data = {}, ...config } = options;
      const params = this.checkContentType(headers, data);
      const network = {
        policy: CachePolicy.NETWORK_ONLY,
      };
      const requestConfig = {
        ...config,
        headers: {
          Authorization: `${this.tokenType} ${this.accessToken}`,
          ...headers,
        },
      };
      if (!_isEmpty(params)) {
        requestConfig.data = params;
      }
      const response = await execute(requestConfig, network);
      if ((response.status >= 200 && response.status <= 208) || response.status === 226) {
        return response;
      } else {
        return Promise.reject(response);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        const _data = _isString(this.config.data) ? qs.parse(this.config.data) : this.config.data;
        const _params = {
          ..._data,
          grant_type: 'refresh_token',
          refresh_token: this.refreshToken,
        };

        const { url, headers: _headers } = this.config;
        await this.authorize(url, _headers, _params);
        return this.request(options);
      }
      return Promise.reject(error);
    }
  };
}
const AuthApi = new Auth();

export { AuthApi };
